export const Strings = {
  titleLeaderBoardTrending:
    "Bharat ka Super Entertainment App | Chingari.io | LeaderBoard Trending",
  titleLeaderBoardRich:
    "Bharat ka Super Entertainment App | Chingari.io | LeaderBoard Rich",
  titleLeaderBoardFans:
    "Bharat ka Super Entertainment App | Chingari.io | LeaderBoard Fans",
  descriptionLeaderBoardTrending:
    "Chingari - India's best Short Video App. Download the app for short music videos, dialogue dubbing videos, create funny videos, dance videos &amp; more. Get started now.",
  descriptionLeaderBoardRich:
    "Chingari - India's best Short Video App. Download the app for short music videos, dialogue dubbing videos, create funny videos, dance videos &amp; more. Get started now.",
  descriptionLeaderBoardFans:
    "Chingari - India's best Short Video App. Download the app for short music videos, dialogue dubbing videos, create funny videos, dance videos &amp; more. Get started now.",
  ChingariCityChampions: "#ChingariCityChampions 🏆",

  // livestream
  liveStreamTitle: "Chingari Creator",
  liveStreamRedirectionTitle:
    "Don't have a Chingari account? <br /> Get the app to join the conversation!",

  cityContentHeaderDescription:
    "The contest is open to all Chingari users. Both content creators and viewers are encouraged to participate and promote city-based content ",
  HELP_CENTER_BODY:
    "If you have any questions or concerns regarding diamond, please don't hesitate to contact us.<br/> You can reach out to us<br/> by calling <a href=tel:+91-8037777000>+91-8037777000</a> or by sending an<br/> email to <a href=mailto:help@chingari.io>help@chingari.io</a>.<br/><br/> Our support team will be more<br/> than happy to assist you with any diamond - related queries that you may have.",
  CITY_CONTEST_IMAGE_BANNER:
    "https://media.chingari.io/uploads/ChingariCityChampion.png",
};
